import React, { Component } from 'react';
import { connect } from 'react-redux';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import s from './Footer.scss';

class Footer extends Component {
	constructor(props) {
		super(props);

		this.footerContainer = React.createRef();
	}

	componentDidMount() {
		if (this.footerContainer.current) {
			this.footerContainer.current.querySelectorAll('div').forEach((column) => {
				column.innerHTML = column.innerHTML.replace(/([\w.\-_]+)\s\[at\]\s([\w.\-_]+)/g, '<a href="mailto:$1@$2">$1@$2</a>');
			});
		}
	}

	componentDidUpdate() {
		if (this.footerContainer.current) {
			this.footerContainer.current.querySelectorAll('div').forEach((column) => {
				column.innerHTML = column.innerHTML.replace(/([\w.\-_]+)\s\[at\]\s([\w.\-_]+)/g, '<a href="mailto:$1@$2">$1@$2</a>');
			});
		}
	}

	render() {
		const { properties, footer, navigation, setup } = this.props;
		if (properties.siteInitiated === false || properties.siteClosed === true) return null;

		return (
			<footer id={translate(setup, navigation.header.slice(-1)[0], 'uri').replace('#', '')} className={s.footer}>
				<div className={s.footer_inner} ref={this.footerContainer}>
					{
						footer?.columns && footer.columns.map((footerColumn) => (
							<div className={[s.footer_inner_column, s[`footer_inner_column__width${footerColumn.columnWidth}`]].join(' ')} key={footerColumn.key} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, footerColumn.text).replace('%year%', new Date(Date.now()).getFullYear())) }} />
						))
					}
				</div>
			</footer>
		);
	}
}

const mapState = ({ environment }) => {
	const { properties, setup, footer, navigation } = environment;
	return { properties, setup, footer, navigation };
};

export default connect(mapState)(Footer);
